/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component';
const styles_DataTableRowWrapperComponent:any[] = ([] as any[]);
export const RenderType_DataTableRowWrapperComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableRowWrapperComponent,data:{}});
function View_DataTableRowWrapperComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n      ']))],(null as any),
      (null as any));
}
function View_DataTableRowWrapperComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),2,(null as any),
      View_DataTableRowWrapperComponent_3)),i0.ɵdid(1,540672,(null as any),0,i1.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet'],ngOutletContext:[1,
          'ngOutletContext']},(null as any)),i0.ɵpod(2,{row:0}),(_l()(),i0.ɵand(0,
      (null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.rowDetail.template;
    const currVal_1:any = _ck(_v,2,0,_co.row);
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_DataTableRowWrapperComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'datatable-row-detail']],[[4,'height','px']],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableRowWrapperComponent_2)),
      i0.ɵdid(3,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = (_co.rowDetail && _co.rowDetail.template);
        _ck(_v,3,0,currVal_1);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.detailRowHeight;
        _ck(_v,0,0,currVal_0);
      });
}
export function View_DataTableRowWrapperComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),i0.ɵncd((null as any),
      0),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_DataTableRowWrapperComponent_1)),i0.ɵdid(4,
      16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,
      _v) => {
    var _co:i2.DataTableRowWrapperComponent = _v.component;
    const currVal_0:any = _co.expanded;
    _ck(_v,4,0,currVal_0);
  },(null as any));
}
export function View_DataTableRowWrapperComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'datatable-row-wrapper',
      [['class','datatable-row-wrapper']],(null as any),[[(null as any),'contextmenu']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('contextmenu' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onContextmenu($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_DataTableRowWrapperComponent_0,RenderType_DataTableRowWrapperComponent)),
      i0.ɵdid(1,49152,(null as any),0,i2.DataTableRowWrapperComponent,([] as any[]),
          (null as any),(null as any))],(null as any),(null as any));
}
export const DataTableRowWrapperComponentNgFactory:i0.ComponentFactory<i2.DataTableRowWrapperComponent> = i0.ɵccf('datatable-row-wrapper',
    i2.DataTableRowWrapperComponent,View_DataTableRowWrapperComponent_Host_0,{rowDetail:'rowDetail',
        detailRowHeight:'detailRowHeight',expanded:'expanded',row:'row'},{rowContextmenu:'rowContextmenu'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/src/$$_gendir/node_modules/@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component.ngfactory.ts